module.exports = __webpack_public_path__ + "static/media/AutoCAD OEM.d1c98544.png";